<template>
  <Suspense timeout="0">
    <template #default>
      <MainComponent></MainComponent>
    </template>
    <template #fallback>
      <main>
        <LoadingComponent></LoadingComponent>
      </main>
    </template>
  </Suspense>
</template>
<script>
import MainComponent from "@/components/MainComponent";
import LoadingComponent from "@/layouts/LoadingComponent";

export default {
  name: "App",
  components: {MainComponent, LoadingComponent}
};
</script>
<style lang="sass">
  @import "@/style/main.scss"
</style>